import { fetchJson } from "./aor-jsonapi-client/fetch";
import jsonAPIRestClient from "./aor-jsonapi-client/restClient";
import {CREATE, UPDATE} from "admin-on-rest";
import HttpError from "./aor-jsonapi-client/HttpError";

const activationPageHttpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: "application/vnd.api+json" });
    }
    options.headers.set("Authorization", process.env.REACT_APP_AUTH_HEADER);
    options.headers.set("X-Source", "activation_page");

    const token = localStorage.getItem("token");
    if (token) {
        options.headers.append("Authorization", "Bearer " + token);
    }

    return fetchJson(url, options);
};

const activationPageRestClient = jsonAPIRestClient(process.env.REACT_APP_API_URL, activationPageHttpClient);

export const createCustomer = (data) => activationPageRestClient(CREATE, 'customers', {data});
export const updateCustomer = (id, data) => activationPageRestClient(UPDATE, 'customers', {id,data});

export const createGiftCard = async (
    customerID,
    kioskId,
    promoId,
    new_customer
  ) => {
  
    const createData = {
      data: {
        type: "gift_cards",
        attributes: {
          value: 0,
          state: "new",
          new_customer: new_customer
        },
        relationships: {
          kiosk: {
            data: {
              id: `${kioskId}`,
              type: "kiosks"
            }
          },
          promo: {
            data: {
              id: promoId,
              type: "promos"
            }
          },
          customer: {
            data: {
              id: `${customerID}`,
              type: "customers"
            }
          }
        }
      }
    };
  
    const url = `${process.env.REACT_APP_API_URL}/gift_cards`;
  
    const response = await fetch(url, {
      method: "POST",
      headers: getHeaders(true),
      body: JSON.stringify(createData)
    });
    const r = await response.json();
    const cardId = r.data.id;
    const url2 = `${url}/${cardId}`;
    const updateData = {
      data: {
        type: "gift_cards",
        id: cardId,
        attributes: {
          state: "processing",
          new_customer: new_customer
        },
      }
    }
    const response2 = await fetch(url2, {
      method: "PATCH",
      headers: getHeaders(true),
      body: JSON.stringify(updateData)
    });
    const r2 = await response2.json();
    const err1 = response.status < 200 || response.status >= 300 ||response.status < 200 || response.status >= 300;
    const err2 = response2.status < 200 || response2.status >= 300 ||response2.status < 200 || response2.status >= 300;
    const err = err1 || err2;
    return {
      success: !err,
      message: (r2.meta && r2.meta.message) ? r2.meta.message : null
    };
  };

  export const fetchGiftcardPromos = () => {

    const kiosk = JSON.parse(localStorage.getItem("kiosk"));
    if (!kiosk || !kiosk.id) {
      throw new HttpError("unauthorized", 401);
    }
    const kioskId = kiosk.id;
  
    // check if voucher code exists
    let time_now = Date.now();
    let d = new Date(time_now);
    const now = d.toISOString();
  
    const filter = `filter[active]=true&filter[valid_from_lte]=${now}&filter[valid_to_gte]=${now}`;
  
    return fetch(`${process.env.REACT_APP_API_URL}/kiosks/${kioskId}/giftcard_promotions?${filter}`, {
      method: "GET",
      headers: getHeaders(true),
    }).then(response => {
      if(response.status < 200 || response.status >= 300) {
        throw new Error('Promotions fetch failed.');
      }
  
      return response.json().then(resp => ({promos: resp.data, kioskId}))
    })
  }

  export const fetchCustomer = (phone) => {
    const phoneNumberUrlEncode = encodeURIComponent(phone);
    const url = `customers?filter[phone]=${phoneNumberUrlEncode}`;
    
    return fetch(`${process.env.REACT_APP_API_URL}/${url}`, {
      method: "GET",
      headers: getHeaders(true),
    }).then(response => {
      if(response.status < 200 || response.status >= 300) {
        throw new Error('Promotions fetch failed.');
      }
  
      return response.json()
        .then(customers => customers.data.length === 1 ? customers.data[0] : null);
    })
  }
  
  const getHeaders = (activationPage = false) => {
    const headers = new Headers(
      {
        Accept: "application/vnd.api+json",
        "X-Source": activationPage ? "activation_page" : "crm",
        "content-type": "application/vnd.api+json"
      });
  
    headers.set("Authorization", process.env.REACT_APP_AUTH_HEADER);
    const token = localStorage.getItem("token");
    if (token) {
      headers.append("Authorization", "Bearer " + token);
    }
    return headers;
  }
  
  


// WEBPACK FOOTER //
// ./src/restClientActivationPage.js